import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { gsap } from "gsap";

function ScrollManager() {
  const location = useLocation();
  const previousLocationRef = useRef({
    pathname: location.pathname,
    hash: location.hash
  });

  useEffect(() => {
    const pathnameChanged = previousLocationRef.current.pathname !== location.pathname;
    const hashChanged = previousLocationRef.current.hash !== location.hash;

    if (!pathnameChanged && !hashChanged) {
      return;
    }

    previousLocationRef.current = {
      pathname: location.pathname,
      hash: location.hash
    };

    const scrollToHashTarget = () => {
      if (!location.hash) return false;

      const rawId = decodeURIComponent(location.hash.slice(1));
      const hashTarget = document.getElementById(rawId);

      if (hashTarget) {
        hashTarget.scrollIntoView({ behavior: "smooth", block: "start" });
        return true;
      }

      return false;
    };

    if (pathnameChanged) {
      const didScrollToHash = scrollToHashTarget();
      if (!didScrollToHash && location.hash) {
        window.setTimeout(() => {
          scrollToHashTarget();
        }, 140);
      }

      if (!didScrollToHash) {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      }

      const mainElement = document.querySelector("main");
      if (mainElement) {
        gsap.killTweensOf(mainElement);
        gsap.fromTo(
          mainElement,
          { opacity: 0.88, y: 14 },
          {
            opacity: 1,
            y: 0,
            duration: 0.46,
            ease: "power2.out",
            clearProps: "opacity,transform"
          }
        );
      }
    } else if (hashChanged) {
      window.setTimeout(() => {
        scrollToHashTarget();
      }, 120);
    }
  }, [location.pathname, location.hash]);

  return null;
}

export default ScrollManager;
